import { ParsePostingAdapters } from '../adapters';
import { PermanentJobsApi } from '../clients';
import { IParsePostingApiRequest, IParsePostingResult } from '../types';

export const parsePosting = async (
  payload: IParsePostingApiRequest,
): Promise<IParsePostingResult> => {
  const response = await PermanentJobsApi.parsePosting(payload);

  return ParsePostingAdapters.toParsePostingResult(response);
};
